export * from './linescape-4-anniversary-transhipment-voyage.component';


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-4-anniversary-transhipment-voyage/index.ts